/**
 * localStorage that never throws. Storage can be unavailable (private
 * windows, blocked site data), and these preferences are only conveniences.
 */

export function readStorage(key) {
    try {
        return window.localStorage.getItem(key);
    } catch (e) {
        return null;
    }
}

export function writeStorage(key, value) {
    try {
        window.localStorage.setItem(key, value);
    } catch (e) {
        /* the preference just isn't remembered */
    }
}
